import { motion } from "framer-motion";

export default function Marquee({ text }) {
  const items = Array.from({ length: 4 });
  return (
    <section aria-hidden className="border-y border-[#E5E3DC] bg-[#F1EEE7] overflow-hidden">
      <motion.div
        className="flex whitespace-nowrap py-6 will-change-transform"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ ease: "linear", duration: 42, repeat: Infinity }}
      >
        {items.map((_, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-4xl sm:text-6xl lg:text-7xl text-[#121316] px-8">
              {text}
            </span>
            <span className="w-2 h-2 rounded-full bg-[#C27835] mx-6" />
          </span>
        ))}
      </motion.div>
    </section>
  );
}
